<template>
    <div>
        <table class="table">
            <thead>
                <tr>
                    <th>Type Code</th>
                    <th>Operation</th>
                    <th>Quantity</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="pkb in showData">
                    <td>{{ pkb.code }}</td>
                    <td>{{ pkb.pkb }}</td>
                    <td>{{ numberWithCommas(pkb.count) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                showData : [{
                    code : '-',
                    pkb : 'No Data',
                    count : 1,
                }]
            }
        },
        props : ['data'],
        mounted () {
            // this.generateDummyData();
        },
        watch : {
            'data' : {
                handler : 'generateData',
                immediate : true,
            }
        },
        methods : {
            generateData () {
                if (this.data != null && this.data.length > 0) this.showData = this.data;
            },
            generateDummyData () {
                let data = []

                for (var i = 0; i < 100; i++) {
                    data.push({
                        code : i+1,
                        pkb : `test ${i+1}`,
                        count : this.randomInt(100, 100000)
                    })
                }

                this.showData = data;
            },
        }
    }
</script>

<style scoped>
    table tbody {
        max-height: 200px;
        display: block;
        overflow: auto;
    }

    thead, tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    thead th {
        border-bottom: 0.5px solid #FF0009 !important;
    }

    tbody td {
        border: 0;
    }

    thead {
        width: calc(100% - 1em);
    }
    table {
        width: 100%;
    }
</style>